<main class="main">
  <section class="content">
    <router-outlet></router-outlet>
  </section>
</main>

<section class="footer">
  <router-outlet name="footer"></router-outlet>
</section>

<ui-kit-svg-atlas></ui-kit-svg-atlas>
<svg aria-hidden="true" style="position: absolute; width: 0; height: 0; overflow: hidden;">
  <symbol id="comment" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M1 3C1 2.44772 1.44772 2 2 2H22C22.5523 2 23 2.44772 23 3V18C23 18.5523 22.5523 19 22 19H11.7361L6.94721 21.3944C6.63723 21.5494 6.26909 21.5329 5.97427 21.3507C5.67945 21.1684 5.5 20.8466 5.5 20.5V19H2C1.44772 19 1 18.5523 1 18V3ZM3 4V17H6.5C7.05228 17 7.5 17.4477 7.5 18V18.882L11.0528 17.1056C11.1916 17.0361 11.3448 17 11.5 17H21V4H3Z" fill="currentColor"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M7 8.75C7.55228 8.75 8 9.19772 8 9.75V11.25C8 11.8023 7.55228 12.25 7 12.25C6.44772 12.25 6 11.8023 6 11.25V9.75C6 9.19772 6.44772 8.75 7 8.75Z" fill="currentColor"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 8.75C12.5523 8.75 13 9.19772 13 9.75V11.25C13 11.8023 12.5523 12.25 12 12.25C11.4477 12.25 11 11.8023 11 11.25V9.75C11 9.19772 11.4477 8.75 12 8.75Z" fill="currentColor"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M17 8.75C17.5523 8.75 18 9.19772 18 9.75V11.25C18 11.8023 17.5523 12.25 17 12.25C16.4477 12.25 16 11.8023 16 11.25V9.75C16 9.19772 16.4477 8.75 17 8.75Z" fill="currentColor"/>
  </symbol>
</svg>
